<template>
  <div class="content container" v-loading="loading">

    <div class="mb-3">
      <router-link :to="{ name: 'Dashboard' }">
        <el-button plain size="small"><span class="el-icon-arrow-left"></span> Dashboard</el-button>
      </router-link>
    </div>

    <h3 class="mb-4">Data protection</h3>

    <div v-if="isUnderProtection">

      <span class="b-pf-icon b-pf-icon--medium"></span>
      Your data is already under protection. You can't cancel this.

    </div>
    <div v-else>

      <protection-settings />

    </div>

    <div v-if="accountSettings">
      <hr />

      <h3 class="mb-4">Reservation settings</h3>

      <hours-editor v-if="accountSettings.reservation && accountSettings.reservation.hours" v-model="accountSettings.reservation.hours" />

      <hr />

      <special-hours-editor v-if="accountSettings.reservation && accountSettings.reservation.specialDays" v-model="accountSettings.reservation.specialDays" />

      <el-button type="primary" @click="saveReservationSettings">Save reservation settings</el-button>

      <router-link :to="{ name: 'ManageRooms' }">
        <el-button type="default">Manage rooms</el-button>
      </router-link>
    </div>

    <hr />

    <h3 class="mb-4">Google Analytics</h3>

    <el-button type="primary" @click="googleAuth">Login with Google Account</el-button>
    <el-button type="default" @click="forgotGoogleAccount" v-if="accountSettings.googleAnalytics">Forgot Google Account</el-button>

    <div class="mt-4 mb-2" v-if="accountSettings.googleAnalytics">

      Forms are tracking on sites:

    </div>

    <ul v-if="accountSettings.googleAnalytics">
      <li v-for="profile in accountSettings.googleAnalytics.profiles">
        {{profile.websiteUrl}}
      </li>
    </ul>

    <hr />

    <h3 class="mb-4">Email settings</h3>

    <el-checkbox v-model="accountSettings.smtp.useCustomSmtp">Use custom STMP server</el-checkbox>

    <div v-if="accountSettings.smtp.useCustomSmtp">

      <el-input style="margin-bottom: 10px" v-model="accountSettings.smtp.noreplyEmail" placeholder="No reply email" />

      <el-input style="margin-bottom: 10px" v-model="accountSettings.smtp.smtpHost" placeholder="Mail Server" />

      <el-input style="margin-bottom: 10px" v-model="accountSettings.smtp.smtpUser" placeholder="Username" />

      <el-input style="margin-bottom: 10px" v-model="accountSettings.smtp.smtpPass" type="password" placeholder="Password" />

      <el-input style="margin-bottom: 10px" v-model="accountSettings.smtp.smtpPort" placeholder="Port" />

      <el-checkbox v-model="accountSettings.smtp.smtpSecure">TLS/SSL</el-checkbox>

      <div>
      <el-button type="primary" @click="saveSmtpSettings">Save</el-button>
      </div>
    </div>

    <hr />

    <h3 class="mb-4">Export all data</h3>

    <el-button type="default" @click="exportForm">Export as ZIP archive</el-button>
  </div>
</template>

<script>
  import Vue from 'vue'
  import protectionSettings from "components/protectionSettings"
  import HoursEditor from "components/HoursEditor"
  import SpecialHoursEditor from "components/SpecialHoursEditor"
  import config from '../../config'

  export default {
    components: {
      protectionSettings,
      HoursEditor,
      SpecialHoursEditor
    },
    data() {
      return {
        loading: false
      }
    },
    async mounted() {
      this.loading = true;
      await this.$store.dispatch('getAccountSettings');
      this.loading = false;
    },
    computed: {
      accountSettings() {
        return this.$store.state.accountSettings;
      },
      isUnderProtection() {
        return this.accountSettings && this.accountSettings.encryption && this.accountSettings.encryption.isEnabled;
      }
    },
    methods: {
      async saveReservationSettings() {
        this.loading = true;
        try {
          await this.$store.dispatch('saveReservations', this.accountSettings.reservation);

          this.$message.success('Saved!');
        } catch (err) {
          this.$message.error(err);
        }
        this.loading = false;
      },
      async saveSmtpSettings() {
        this.loading = true;
        try {
          await this.$store.dispatch('saveSmtp', this.accountSettings.smtp);

          this.$message.success('Saved!');
        } catch (err) {
          this.$message.error(err);
        }
        this.loading = false;
      },
      exportForm() {
        window.location.href = config.getApiUrl() + '/v1/forms-export?accountId=' + this.$store.state.accountId;
      },
      googleAuth() {
        Vue.googleAuth().signIn(async (authorizationCode) => {
          await this.$store.dispatch('attachGoogleAccount', authorizationCode);
        }, (error) => {
          console.info(error);
        });
      },
      async forgotGoogleAccount() {
        await this.$store.dispatch('dettachGoogleAccount');
      }
    }
  };
</script>



// WEBPACK FOOTER //
// Settings.vue?25556118